var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkieTalkie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2C18 1.58579 17.6642 1.25 17.25 1.25C16.8358 1.25 16.5 1.58579 16.5 2V4.06301C16.3402 4.02188 16.1726 4 16 4H8C6.89543 4 6 4.89543 6 6V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V2ZM8 7C8 6.44772 8.44771 6 9 6H15C15.5523 6 16 6.44772 16 7V11C16 11.5523 15.5523 12 15 12H9C8.44771 12 8 11.5523 8 11V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkieTalkie);
export default __webpack_public_path__ + "static/media/walkie-talkie.da2a88539f4f97e5fc80eab113528294.svg";
export { ForwardRef as ReactComponent };